import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { withStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { setupPasswordWithToken } from 'redux/user/actions';
import withQueryParams from 'components/base/withQueryParams';
import LoggedOutLayout from 'components/base/LoggedOutLayout';
import Logo from 'components/base/Logo/LoginLogo';
import styles from './styles';
import ChangePasswordForm from '../ChangePassword/ChangePasswordForm';
import { login } from '../../../constants/routing';

class SetupPassword extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      setPasswordSuccess: false,
    };
  }

  async onSubmit(formData) {
    try {
      await this.props.setupPasswordWithToken(formData.password, formData.confirmPassword, this.props.resetCode);

      this.handleSuccess();
      this.props.history.push(login());
    } catch (error) {
      if (error.errors) {
        throw new SubmissionError(error.errors);
      }
    }
  }

  handleSuccess = () => {
    this.setState({
      setPasswordSuccess: true,
    });
  }

  render() {
    const { classes } = this.props;
    const { setPasswordSuccess } = this.state;

    return (
      <LoggedOutLayout>
        <div className={classes.card}>
          <Logo />
          <Card>
            { (!isEmpty(setPasswordSuccess) || !setPasswordSuccess) &&
            <ChangePasswordForm onSubmit={data => this.onSubmit(data)} classes={classes} /> }
          </Card>
        </div>
      </LoggedOutLayout>
    );
  }
}

SetupPassword.propTypes = {
  setupPasswordWithToken: PropTypes.func.isRequired,
  classes: PropTypes.shape({
    card: PropTypes.string.isRequired,
  }).isRequired,
  resetCode: PropTypes.string,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

SetupPassword.defaultProps = {
  resetCode: null,
};

const paramsToProps = ({ code }) => ({
  resetCode: code,
});

export default connect(
  state => ({
    auth: state.auth,
  }),
  { setupPasswordWithToken },
)(withQueryParams(paramsToProps)(withStyles(styles)(SetupPassword)));
